import axios from 'axios';

const verificationApi = axios.create({
  baseURL: import.meta.env.VITE_VERIFICATION_API_BASE_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for logging
verificationApi.interceptors.request.use(
  (config) => {
    console.log('Verification API Request:', {
      method: config.method?.toUpperCase(),
      url: config.url,
      baseURL: config.baseURL,
      data: config.data
    });
    return config;
  },
  (error) => {
    console.error('Verification API Request Error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for logging
verificationApi.interceptors.response.use(
  (response) => {
    console.log('Verification API Response:', {
      status: response.status,
      statusText: response.statusText,
      data: response.data
    });
    return response;
  },
  (error) => {
    console.error('Verification API Response Error:', {
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      message: error.message
    });
    return Promise.reject(error);
  }
);

export default verificationApi;